import { useEffect, useRef, useCallback } from 'react';
import { isCrossWindowMessage, postCrossWindowMessage, } from '@business/cross-window-message';
export const useCrossWindowMessage = (options = {}) => {
    const { targetOrigin = '*', onMessage } = options;
    const handlerRef = useRef(undefined);
    useEffect(() => {
        handlerRef.current = onMessage;
    }, [onMessage]);
    // Set up message listener
    useEffect(() => {
        const listener = (event) => {
            var _a;
            // Check if the message is a valid cross-window message
            if (isCrossWindowMessage(event.data)) {
                // Parse serialized payloads
                const payload = typeof event.data.payload === 'string'
                    ? JSON.parse(event.data.payload)
                    : event.data.payload;
                (_a = handlerRef.current) === null || _a === void 0 ? void 0 : _a.call(handlerRef, {
                    payload,
                    source: event.source,
                    type: event.data.type,
                });
            }
        };
        window.addEventListener('message', listener);
        return () => {
            window.removeEventListener('message', listener);
        };
    }, []);
    // Send a message
    const postMessage = useCallback((target, type, payload) => {
        postCrossWindowMessage(target, type, payload, targetOrigin);
    }, [targetOrigin]);
    return {
        postMessage,
    };
};
